import React, { useState } from 'react';
import {
    ValidationForm,
    Grid,
    Cell,
    Btn,
    Box,
    P,
    FieldCheckbox,
} from '@saladbob/sassafras'

import { MackerTagField, Text } from './Fields';

import { User } from '../../types';
import Upload from '../Upload';
import { X } from 'react-feather';

type Props = {
    onSubmit: Function,
    setUser?: Function,
    user: User & { password?: string, password_confirm?: string },
    children?: React.ReactNode,
};

const column = {
    phone: 'span 2',
    laptop: 'span 1',
}

const CreateUserAccount: React.FC<Props> = ({ user, onSubmit, children }) => {
    return (
        <ValidationForm onSubmit={onSubmit}>
            <Grid bgColor="white" columns={{ phone: '1fr', laptop: '1fr 1fr' }} gridGap={{ phone: 'sm', laptop: 'lg' }} mb="md">
                <Cell column={column}>
                    <Text value={user?.fname} label="First Name" name="fname" rules={{ required: true, minlength: 3  }} />
                </Cell>
                <Cell column={column}>
                    <Text value={user?.lname} label="Last Name" name="lname" rules={{  required: true, minlength: 3  }} />
                </Cell>
                <Cell column="span 2">
                    <Text
                        value={user?.email}
                        type="email"
                        label="Email"
                        name="email"
                        rules={{
                            required: true,
                            email: true,
                            checkEmail: async (value: string) => {
                                if (user?.email) {
                                    return { valid: true };
                                }
                                const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/user/account-exists/${value}`).then((r) => r.json());
                                return {
                                    valid: res.valid,
                                    message: 'An account with this email already exists, try logging.',
                                };
                            },
                        }}
                    />
                </Cell>
                <Cell column={column}>
                    <Text
                        value={user.password}
                        label="Password"
                        type="password"
                        name="password"
                        rules={{ required: true, password: true  }}
                    />
                </Cell>
                <Cell column={column}>
                    <Text
                        value={user.password_confirm}
                        label="Confirm Password"
                        name="password_confirm"
                        type="password"
                        rules={{
                            equalTo: 'password',
                            required: true, 
                        }}
                    />
                </Cell>
            </Grid>
            {children}
        </ValidationForm>
    );
}

const UserAccount: React.FC<Props> = ({ user, setUser, onSubmit, children }) => {
    const [changePassword, setChangePassword] = useState(false);
    const showMackerTag = user?.type === 'player';
    return (
        <ValidationForm onSubmit={onSubmit}>
            <Grid columns="120px 1fr" gridGap="lg" mb="md" padding={['lg', 0]} align="center">
                <Box maxWidth="120px" margin="auto">
                    {!user.imageUpload && user.image && user.image.url
                        ? (<Box
                                height="120px"
                                bgImage={user.image.sizes.thumbnail.url || user.image.url}
                                rounded="100%"
                                align="flex-start"
                                justify="flex-start"
                            >
                                <Btn size="xs" color="black" type="button" onClick={() => setUser({ image: null })}>
                                    <X size="14px" />
                                </Btn>
                            </Box>)
                        : (<Upload
                            name="logo"
                            onChange={(image) => setUser({ imageUpload: image })}
                        />)
                    }
                </Box>
                {showMackerTag && !user.mackertag && (
                    <MackerTagField user={user}/>
                )}
                {showMackerTag && user.mackertag?.length > 0 && (
                    <P font="h2" mb="0">
                        @{user.mackertag}
                    </P>
                )}
            </Grid>
            <Grid bgColor="white" columns="1fr 1fr" gridGap="lg" mb="md">
                <Cell column={{ phone: 'span 2', laptop: 'span 1' }}>
                    <Text value={user?.fname} label="First Name" name="fname" rules={{ minlength: 3  }} />
                </Cell>
                <Cell column={{ phone: 'span 2', laptop: 'span 1' }}>
                    <Text value={user?.lname} label="Last Name" name="lname" rules={{  minlength: 3  }} />
                </Cell>
                <Cell column="span 2">
                    <Text value={user?.email} type="email" label="Email" name="email" rules={{ email: true  }} />
                </Cell>
                {changePassword && (
                    <>
                        <Cell column="span 2">
                            <Text label="Password" type="password" name="password" rules={{ password: true  }} />
                        </Cell>
                        <Cell column="span 2">
                            <Text label="Confirm Password" name="password_confirm" type="password" rules={{
                                Text: true,
                                equalTo: 'password',
                            }}/>
                        </Cell>
                        <Cell column="span 2">
                            <Btn size="sm" color="neutral" outline onClick={() => setChangePassword(false)}>Cancel</Btn>
                        </Cell>
                    </>
                )}
                {!changePassword && (
                    <Cell column="span 2">
                        <Btn size="sm" color="neutral" outline onClick={() => setChangePassword(true)}>Change Password</Btn>
                    </Cell>
                )}
                <Cell column="span 2">
                    <FieldCheckbox
                        size="xs"
                        name="sms"
                        mb="0"
                        checked={user?.sms ? true : false}
                        inline={false}
                        label={(
                            <P mb="0">
                                I want to receive text messages from Gus Macker. Stay in the game with real-time updates and exclusive notifications for Gus Macker
                                basketball events!
                            </P>
                        )}
                    />
                </Cell>
            </Grid>
            {children}
        </ValidationForm>
    );
}

export default UserAccount;

export { CreateUserAccount }
